import { Pipe, PipeTransform } from '@angular/core';
import { isCVSplitApplied } from 'src/app/helpers/isCvSplitApplied';
import storage from 'store';

@Pipe({
  name: 'productName'
})
export class ProductNamePipe implements PipeTransform {

  isCVSplitApplied = isCVSplitApplied();

  products = [];

  constructor() {
    const autocomplete = storage.get('autocomplete');
    this.products = this.isCVSplitApplied ? autocomplete.products_new : autocomplete.products;
  }

  transform(product: string): any {
    if(this.isCVSplitApplied) {
      const productNew = this.products.find(p => p.value === product);
      return productNew ? productNew.label : product;
    }
    
    switch (product) {
      case 'IELTS Ashton - Retention - General Course':
        return 'IELTS Conley University - Retention - General Course';
      case 'IELTS Ashton - Retention - Academic Course':
        return 'IELTS Conley University - Retention - Academic Course';
      default:
        return product;
    }
  }

}
